import {
    ApplicationConfig,
    ErrorHandler,
    provideZonelessChangeDetection,
} from '@angular/core';
import {
    provideRouter,
    withComponentInputBinding,
    withInMemoryScrolling,
} from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideNgcCookieConsent } from 'ngx-cookieconsent';
import { cookieConfig } from './cookie.config';
import {
    provideClientHydration,
    withEventReplay,
    withHttpTransferCacheOptions,
} from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { createErrorHandler } from '@sentry/angular';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZonelessChangeDetection(),
        provideAnimationsAsync(),
        provideRouter(
            routes,
            withComponentInputBinding(),
            withInMemoryScrolling({
                scrollPositionRestoration: 'top',
                anchorScrolling: 'enabled',
            }),
        ),
        provideHttpClient(withFetch()),
        provideTranslateService({
            defaultLanguage: 'de',
        }),
        provideNgcCookieConsent(cookieConfig),
        {
            provide: ErrorHandler,
            useValue: createErrorHandler(),
        },
        provideClientHydration(
            withEventReplay(),
            withHttpTransferCacheOptions({ includePostRequests: true }),
        ),
    ],
};
